<script lang="ts">
  import LoadingMessages from './LoadingMessages.svelte';
  import TeoBall, { type TeoBallVariant } from './TeoBall.svelte';

  let {
    cycleDuration = 6000,
    messages = [],
    class: className,
    ...props
  }: {
    cycleDuration?: number;
    messages?: string[];
    class?: string;
  } & Record<string, unknown> = $props();

  let variant: TeoBallVariant = $state('idle-right');
  let transitionDuration = $derived(`${cycleDuration / 3}ms`);

  $effect(() => {
    variant = 'idle-right';
    const halfCycle = cycleDuration / 2;
    const leadTime = cycleDuration / 6;

    const firstTimeout = setTimeout(() => {
      variant = 'idle-left';
      interval = setInterval(() => {
        variant = variant === 'idle-right' ? 'idle-left' : 'idle-right';
      }, halfCycle);
    }, halfCycle - leadTime);

    let interval: ReturnType<typeof setInterval>;

    return () => {
      clearTimeout(firstTimeout);
      clearInterval(interval);
    };
  });
</script>

<div class="flex flex-col {className}" {...props}>
  <div class="loading-container relative flex-1 overflow-hidden" style:--cycle="{cycleDuration}ms">
    <div class="loading-slide absolute inset-y-0 aspect-square">
      <TeoBall {variant} {transitionDuration} class="size-full" />
    </div>
  </div>

  <LoadingMessages {messages} rotateInterval={6000} />
</div>

<style>
  .loading-container {
    container-type: size;
  }

  @keyframes slide {
    0%,
    100% {
      transform: translateX(0);
    }
    50% {
      transform: translateX(calc(100cqw - 100%));
    }
  }

  .loading-slide {
    animation: slide var(--cycle) ease-in-out infinite;
  }
</style>
